import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { HomePage } from '../home/pages/HomePage';
import { Role } from '../Security/models/Authorization';

import { CreateEnvironment } from './EnvironmentVariable/pages/createEnvironment/createEnvironment.lazy';
import { EditEnvironment } from './EnvironmentVariable/pages/editEnvironment/editEnvironment.lazy';
import { ListEnvironmentVariable } from './EnvironmentVariable/pages/listEnvironment/listEnvironment.lazy';
import { HomeTemplate as AdminHomeTemplate } from './HomeTemplate/pages/homeTemplate/homeTemplate.lazy';
import { NotificationTemplate } from './NotificationTemplate/pages/notificationTemplate/notificationTemplate.lazy';
import { TaxpayerFieldRegistration } from './TaxpayerFieldRegistration/pages/taxpayerFieldRegistration/taxpayerFieldRegistration.lazy';
import { TermsTemplate } from './TermsTemplate/Loadable';
export const ParametersRouting = () => {
  return (
    <Routes>
      <Route
        path="application/notification-template"
        element={
          <RouteAuth access={[Role.NotificationsAdmin]}>
            <NotificationTemplate key="application" system={'application'} />
          </RouteAuth>
        }
      />
      <Route
        path="security/notification-template"
        element={
          <RouteAuth access={[Role.NotificationsAdmin]}>
            <NotificationTemplate key="security" system={'security'} />
          </RouteAuth>
        }
      />
      <Route
        path="taxpayer-fields"
        element={
          <RouteAuth access={[Role.TaxpayersAdmin]}>
            <TaxpayerFieldRegistration />
          </RouteAuth>
        }
      />

      <Route
        path=":system/environment"
        element={
          <RouteAuth access={[Role.EnvironmentsAdmin]}>
            <ListEnvironmentVariable />
          </RouteAuth>
        }
      />
      <Route
        path=":system/environment/create"
        element={
          <RouteAuth access={[Role.EnvironmentsAdmin]}>
            <CreateEnvironment />
          </RouteAuth>
        }
      />

      <Route
        path=":system/environment/:id/edit"
        element={
          <RouteAuth access={[Role.EnvironmentsAdmin]}>
            <EditEnvironment />
          </RouteAuth>
        }
      />

      {/* <Route
        path="catalog-type"
        element={
          <RouteAuth access={[Role.CatalogsAdmin]}>
            <CatalogType />
          </RouteAuth>
        }
      /> */}
      <Route
        path="home-template"
        element={
          <RouteAuth access={[Role.EnvironmentsAdmin]}>
            <AdminHomeTemplate />
          </RouteAuth>
        }
      />
      <Route
        path="terms-template"
        element={
          <RouteAuth access={[Role.EnvironmentsAdmin]}>
            <TermsTemplate />
          </RouteAuth>
        }
      />
      <Route path="" element={<HomePage />} />
    </Routes>
  );
};
